module.exports = __webpack_public_path__ + "img/html-evolution-14.5ec2c9af.jpg";